var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-menu',{attrs:{"menu":_vm.menu,"collapsed":_vm.collapsed},on:{"toggle-collapse":_vm.onToggleCollapse}})}
var staticRenderFns = []

export { render, staticRenderFns }